import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f6aa184"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5f6aa184&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6aa184')) {
      api.createRecord('5f6aa184', component.options)
    } else {
      api.reload('5f6aa184', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5f6aa184", function () {
      api.rerender('5f6aa184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/accountManagement/details/index.vue"
export default component.exports